export default {
  title01: "Tempo Atual",
  title02: "24 Horas",
  title03: "Ver previsão do tempo para 10 dias",
  title04: "AQI",
  title05: "Ver todas as informações",
  title06: "Nascer e pôr do sol",
  title07: "Fase da lua",
  title08: "Próxima lua cheia",
  title09: "Próxima lua nova",
  title10: "DIA",
  title11: "NOITE",
  title12: "Nascer do Sol",
  title13: "Pôr do Sol",
  title14: "Nascer da Lua",
  title15: "Pôr da Lua",
  title16: "Fonte",
  title17: "Início",
  title18: "Fim",
  title19: "Usar localização atual",
  title20: "Pesquisar a cidade",
  title21: "Sensação Térmica",
  title22: "Sensação Térmica na Sombra",
  title23: "Agora",
  title24: "Hoje",
  title25: "DOM",
  title26: "SEG",
  title27: "TER",
  title28: "QUA",
  title29: "QUI",
  title30: "SEX",
  title31: "SÁB",
  title32: "Carregando...",
  title33: "Agora",
  title34: "Por Hora",
  title35: "Diário",
  title36: "Sol & lua",
  title37: "Qualidade do ar",
  title38: "Contato: xlf550402@gmail.com",
  title39: "Acordo de Privacidade",
  title40: "Direitos Autorais © comfortweather.com 2020 - 2026. Todos os Direitos Reservados.",
  title41: "Dados fornecidos por",
  title42: "Al",
  title43: "Bai",
  title44: "Aceitar",
  title45:
    "Obrigado por usar o ComfortWeather! Para proteger melhor seus direitos e interesses legais, leia atentamente a ",
  title46: "Política de Privacidade",
  title47: " antes de usar.",
  title48: "",
  title49: "Contato: xyjph123@gmail.com",
  title50: "Direitos Autorais © 24hweather.com 2020 - 2026. Todos os Direitos Reservados.",
  title51:
    "Obrigado por usar o 24hweather! Para proteger melhor seus direitos e interesses legais, leia atentamente a ",
  title52: "Detectamos que sua localização foi alterada. Deseja atualizá-la?",
  title53: "Confirmar",
  title54: "Cancelar",
  title55: "Voltar",
  title56: "Notícias",
  title57: "Atualizando o clima...",
  title58: "Clima atualizado",
  title59: "Ver tudo",
  title60: "Direitos Autorais © mobi321.com 2020 - 2026. Todos os Direitos Reservados.",
  title61: "Ontem",
  title62: "Amanhã",
  title63: "Ver previsão do tempo para 15 dias",
  title64: "Detalhes do dia",
  title65: "Rahu Kaal",
  title66: "Preparativos para o clima",
  title67: "Preparativos para o clima",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Difícil de secar",
  title103: "Secagem lenta",
  title104: "Bem seco",
  title105: "Secagem rápida",
  title106: "Secagem muito rápida",

  title107: "Não é adequado",
  title108: "Condições aceitáveis",
  title109: "Ideal para atividades na água",
  title110: "Muito adequado",
  title111: "Condições perfeitas",

  title112: "Favorece a saúde",
  title113: "Condições neutras",
  title114: "Risco ligeiramente maior",
  title115: "Alto risco",
  title116: "Correndo risco extremo",

  title117: "Não é adequado",
  title118: "Pouco adequado",
  title119: "Ideal para atividades ao ar livre.",
  title120: "Muito adequado",
  title121: "Excelentes condições",

  title122: "Condições de pele muito secas",
  title123: "Pele provavelmente seca",
  title124: "Ligeiramente seca",
  title125: "Provavelmente não está seca",
  title126: "Muito improvável que esteja seca",

  title127: "Não recomendado",
  title128: "Aceitável",
  title129: "Dia bom",
  title130: "Ótimas condições.",
  title131: "Condições ideais",
};
